package net.dipgo.game

enum class MoveResult {
    NO_MOVE_MADE,
    SUCCESS,
    FAILURE_SUICIDE,
    FAILURE_KO,
    FAILURE_NOT_THIS_PLAYERS_TURN,
    FAILURE_PLAYER_HAS_ALREADY_RESIGNED,
    // The point already holds a stone, or lies outside the board. Neither can happen from the
    // page, which only offers empty points, but a program can ask for anything.
    FAILURE_POINT_OCCUPIED,
    FAILURE_POINT_OFF_BOARD,
    RESIGNATION,
    GAME_ENDING_RESIGNATION,
    PASS,
    GAME_ENDING_PASS,
    TIMEOUT,
    GAME_ENDING_TIMEOUT,
    // A timeout that was forgiven (recorded as a skipped turn, not a resignation) because
    // the player is still within the game's per-player timeout allowance.
    FORGIVEN_TIMEOUT,
}